// extracted by mini-css-extract-plugin
module.exports = {"header":"Current_header__23C8z","deleteBtn":"Current_deleteBtn__1Logc","selectAll":"Current_selectAll__smlsV"};